export const gitCommit = '61099469'
